import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

export default class Sliders {

  coo() {
    new Swiper(".coo-slider", {
      loop: true,
      autoHeight: true,
      preloadImages: false,
      lazy: true,
      slidesPerView: 2,
      spaceBetween: 10,
      navigation: {
        nextEl: '.coo-slider-nav--next',
        prevEl: '.coo-slider-nav--prev',
      },
      autoplay: {
  			delay: 5000,
  		},
      breakpoints: {
        576: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 40,
        },
        992: {
          slidesPerView: 6,
          spaceBetween: 40,
        },
      },
    });
  }

  
  init() {
      document.querySelector('.coo-slider') ? this.coo() : null;
  }
}